export default function ServiceCalloutBanner({ text, ctaText, ctaUrl, testId }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-5"
      style={{
        background: 'rgba(139,92,246,0.06)',
        border: '1px solid rgba(139,92,246,0.15)',
        borderRadius: 10,
        padding: '1rem 1.5rem',
      }}
    >
      <p
        className="font-body"
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '0.875rem',
          color: 'var(--tm)',
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        {text}
      </p>
      <a
        href={ctaUrl}
        data-testid={`${testId}-cta`}
        className="font-body whitespace-nowrap transition-colors duration-150"
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '0.875rem',
          fontWeight: 500,
          color: 'var(--a)',
          textDecoration: 'none',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--a-bright)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--a)'; }}
      >
        {ctaText}
      </a>
    </div>
  );
}
